<template>
  <!-- Najnoviji oglasi (pocetna): nisu top ni top kategorija, bez slike -->
  <AdsBlock
    :items="items"
    :filter="{ top_ad: 0, top_category: 0 }"
    :limit="8"
    title="Najnoviji oglasi"
    dropdown="subcategory"
    :show-image="false"
  />
</template>

<script setup>
import AdsBlock from '~/components/widgets/Advertisement/AdsBlock.vue'

defineProps({
  items: { type: Array, default: () => [] }
})
</script>
